import React from 'react';
import classnames from 'classnames';
import { ProgressBar } from 'ui/ProgressBar';

interface IConfidenceBarProps {
  value: number;
  className?: string;
}

const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));

export const ConfidenceBar: React.FC<IConfidenceBarProps> = ({ value, className }) => {
  const pct = clamp(value, 0, 100);
  return (
    <div className={classnames('flex flex-col items-center gap-1 w-[70px]', className)}>
      <span className="font-pt-sans text-[11px] text-black leading-none">{pct}%</span>
      <div className="w-full">
        <ProgressBar score={pct} total={100} />
      </div>
    </div>
  );
};
